import isEqual from 'lodash/isEqual';

export const checkDiffAllergenOverlay = ({
  allergenOverlay = {},
  originalAllergen = {},
}) => {
  return !isEqual(allergenOverlay, originalAllergen);
};

export const getOriginalAllergenOfOverlay = ({
  originalAllergens = {},
  path,
}) => {
  return (
    originalAllergens?.allergens?.find((allergen) => allergen?.path === path) ??
    {}
  );
};
